import {Injectable} from '@angular/core';
import {AbstractSaveOneService} from '../../../../../../core/service/v2/service/save/abstractSaveOne.service';
import {SaleInvoiceModel} from '../../entity/saleInvoice.model';
import {SaleInvoiceSavePayload} from './saleInvoiceSave.payload';
import {SaleInvoiceRepository} from '../../../impl/service/ngrx/saleInvoice.repository';
import {SaleInvoiceDataServiceAdapter} from '../../../impl/service/ngrx/saleInvoiceDataService.adapter';
import {SaleRepository} from '../../../../../impl/service/ngrx/Sale.repository';

@Injectable({
    providedIn: 'root'
})
export class SaleInvoiceSaveService extends AbstractSaveOneService<SaleInvoiceModel, SaleInvoiceSavePayload>{

    constructor(repository: SaleInvoiceRepository,
                dataService: SaleInvoiceDataServiceAdapter,
                private saleRepository: SaleRepository) {
        super(repository, dataService);
    }

    protected buildBody(payload: SaleInvoiceSavePayload): any {
        const formData = new FormData();
        let document;
        if (payload.document) {
            document = {
                formatValue: payload.document.formatValue,
                label: payload.document.label
            };
        }

        let report;
        if (payload.report) {
            report = {
                common: {
                    headerReportComponentId: payload.report.common.headerReportComponentId,
                    signatureReportComponentId: payload.report.common.signatureReportComponentId,
                    footerReportComponentId: payload.report.common.footerReportComponentId,
                },
                recipient: payload.report.recipient
            };
        }


        formData.append('saleInvoice', JSON.stringify({
            saleId: payload.saleId,
            date: payload.date,
            statusValue: payload.statusValue,
            number: payload.number,
            documentLabel: payload.documentLabel,
            bookId: payload.bookId,
            document,
            report
        }));
        if (payload.document?.attachment) {
            formData.append('attachment', payload.document.attachment.rawFile);
        }
        return formData;
    }

    protected postSave(entity: SaleInvoiceModel) {
        this.saleRepository.clearCache();
    }
}
